class Elementor_Template{
    static instance;

    static getInstance() {
        if (!Elementor_Template.instance) {
            Elementor_Template.instance = new Elementor_Template();
        }
        return Elementor_Template.instance;
    }

    constructor(){
        elementor.hooks.addAction( 'panel/open_editor/widget/opal-template', (panel) => {
            this.onPanelShow(panel);
        } );
    }

    onPanelShow(panel){
        let templateIdControl = panel.content.currentView.collection.findWhere( { name: 'template_id' } );

        if ( ! templateIdControl || 'template_id' !== templateIdControl.get( 'name' ) ) {
            return; // No templates
        }

        let templateIdInput = panel.content.currentView.children.findByModelCid( templateIdControl.cid );

        // Order templates by name.
        let $controlOptions = templateIdInput.$el.find( 'option' ),
            $select = templateIdInput.$el.find( 'select' ),
            // Keep the first option ( - select -) without order.
            $optionsSelect = $controlOptions.eq( 0 ),
            currentValue = panel.content.currentView.model.get( 'settings' ).get( 'template_id' );

        delete $controlOptions[0];

        $controlOptions.sort( function( a, b ) {
            let c = a.text.toLowerCase(),
                d = b.text.toLowerCase();
            if ( c > d ) {
                return 1;
            } else if ( c < d ) {
                return -1;
            }
            return 0;
        } );

        $select.empty().append( $optionsSelect ).append( $controlOptions );

        // Reset value, because the 'selected option' is changed while play with the options.
        $select.val( currentValue );

        // Change Edit link on change template.
        templateIdInput.on( 'input:change', this.onTemplateIdChange ).trigger( 'input:change' );

    }


    onTemplateIdChange(){
        let templateID = this.options.elementSettingsModel.attributes.template_id,
            type = this.options.model.attributes.types[ templateID ],
            $editButton = this.$el.find( '.elementor-edit-template' );

        if ( '0' === templateID || ! templateID || 'widget' === type ) { // '0' = first option, 'widget' is editable only from Elementor page
            if ( $editButton.length ) {
                $editButton.remove();
            }

            return;
        }

        let editUrl = ElementorConfig.home_url + '?p=' + templateID + '&elementor';

        if ( $editButton.length ) {
            $editButton.prop( 'href', editUrl );
        } else {
            $editButton = jQuery( '<a />', {
                target: '_blank',
                'class': 'elementor-button elementor-button-default elementor-edit-template',
                href: editUrl,
                html: '<i class="fa fa-pencil" /> Edit Template'
            } );

            this.$el.find( '.elementor-control-input-wrapper' ).after( $editButton );
        }
    }
}

Elementor_Template.getInstance();